document.addEventListener('change', function (event) {
  const input = event.target;

  // Only react to product variant/color selections
  if (
    !input.matches(
      'variant-picker input[type="radio"], variant-picker select'
    )
  ) {
    return;
  }

  // Give Horizon time to update the selected variant and product image
  setTimeout(function () {
    const mediaGallery = document.querySelector(
      'media-gallery'
    );

    if (!mediaGallery) return;

    // Scroll smoothly to the product images
    mediaGallery.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, 300);
});